import React, { useState, useEffect } from "react";
import { TabContent, Nav, NavItem, NavLink } from "reactstrap";
import { Container, Badge } from "reactstrap";
import { PersonalTab, SearchTab } from "components/tabs";
import { useSearchResult, useQuery } from "hooks";
import styles from "./Results.module.css";

const Tab = {
  SEARCH: "search",
  PERSONAL: "personal",
};

const Results = () => {
  const [tab, setTab] = useState(Tab.SEARCH);
  const [result] = useSearchResult();
  const { resultset, query } = useQuery();
  const currentQuery = (query == null ? {} : query).id || "none";
  const [current, setCurrent] = useState(currentQuery);

  useEffect(() => {
    if (currentQuery !== current) {
      setTab(currentQuery !== "none" ? Tab.PERSONAL : Tab.SEARCH);
      setCurrent(currentQuery);
    }
  }, [currentQuery, current]);

  const handleToggle = (t) => {
    if (tab !== t) setTab(t);
  };
  return (
    <Container fluid className={styles.results}>
      <Nav tabs className={styles.tabs}>
        <NavItem>
          <NavLink
            className={`${styles.item}${tab === Tab.SEARCH ? " active" : ""}`}
            onClick={() => {
              handleToggle(Tab.SEARCH);
            }}
          >
            Result
            <Badge color="light" pill>
              {(result.docsCount || 0).toLocaleString()}
            </Badge>
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={`${styles.item}${tab === Tab.PERSONAL ? " active" : ""}`}
            onClick={() => {
              handleToggle(Tab.PERSONAL);
            }}
          >
            Personal Result
            <Badge color="light" pill>
              {(resultset.length || 0).toLocaleString()}
            </Badge>
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={tab}>
        {tab === Tab.SEARCH && <SearchTab tabId={Tab.SEARCH} />}
        {tab === Tab.PERSONAL && <PersonalTab tabId={Tab.PERSONAL} />}
      </TabContent>
    </Container>
  );
};

export { Results };
